/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetTabsCount200ResponseData } from './GetTabsCount200ResponseData'
import {
  GetTabsCount200ResponseDataFromJSON,
  GetTabsCount200ResponseDataFromJSONTyped,
  GetTabsCount200ResponseDataToJSON,
} from './GetTabsCount200ResponseData'

/**
 *
 * @export
 * @interface GetTabsCount200Response
 */
export interface GetTabsCount200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetTabsCount200Response
   */
  status: boolean
  /**
   *
   * @type {GetTabsCount200ResponseData}
   * @memberof GetTabsCount200Response
   */
  data: GetTabsCount200ResponseData
}

/**
 * Check if a given object implements the GetTabsCount200Response interface.
 */
export function instanceOfGetTabsCount200Response(
  value: object
): value is GetTabsCount200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetTabsCount200ResponseFromJSON(
  json: any
): GetTabsCount200Response {
  return GetTabsCount200ResponseFromJSONTyped(json, false)
}

export function GetTabsCount200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetTabsCount200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetTabsCount200ResponseDataFromJSON(json['data']),
  }
}

export function GetTabsCount200ResponseToJSON(
  value?: GetTabsCount200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetTabsCount200ResponseDataToJSON(value['data']),
  }
}
